import { common } from './common';
import { light } from './light';
import { dark } from './dark';
import { additional } from './additional';

const baseTheme = {
    common: common,
    light: light,
    dark: dark,
    additional: additional
}

export default baseTheme;